import React from 'react';
import { blue } from '@mui/material/colors';
import Checkbox from '@mui/material/Checkbox';
import styles from './CheckBox.module.scss';

function CheckBox({ selected, id, label, onChange, disabled }) {
  return (
    <div className={styles.checkboxParent}>
      <Checkbox
        onChange={onChange}
        className={styles.checkbox}
        id={id}
        sx={{
          '&.Mui-checked': {
            color: blue[600]
          }
        }}
        checked={selected}
        color="default"
        disabled={disabled}
      />
      <label className={`${styles.label} form-check-label`} htmlFor={id}>
        {label}
      </label>
    </div>
  );
}

export default CheckBox;
